var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M14.16 26.59a12.11 12.11 0 0 1-8.33-3.33L23 6.1a12.06 12.06 0 0 1 3.33 8.33 1 1 0 0 0 2 0C28.33 6.611 21.992.272 14.173.27 6.354.268.013 6.604.01 14.423c-.004 7.82 6.331 14.161 14.15 14.167a1 1 0 1 0 0-2zm0-24.32a12 12 0 0 1 7.34 2.49l-17 17a12.14 12.14 0 0 1 9.67-19.5l-.01.01zm10 13.78a7.84 7.84 0 0 0-7.84 7.84 7.68 7.68 0 0 0 1.57 4.69 7.78 7.78 0 0 0 5.6 3.12h.67a7.84 7.84 0 0 0 0-15.68v.03zm4.77 11.2a5.8 5.8 0 0 1-4.13 2.44 5.27 5.27 0 0 1-1.13 0 5.8 5.8 0 0 1-4.18-2.33 5.71 5.71 0 0 1-1.17-3.49 5.84 5.84 0 1 1 10.61 3.36v.02zM27 22.89h-2v-2a1 1 0 1 0-2 0v2h-2a1 1 0 0 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#636176",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestCancel);
export default __webpack_public_path__ + "static/media/request-cancel.d5a12e229fcc0cce7fdac48210ff0b1a.svg";
export { ForwardRef as ReactComponent };